import React from 'react';
import WizardNumberInput from 'components/v2/epd-wizard-inputs/WizardNumberInput';
import WizardTextInputComponent from 'components/v2/epd-wizard-inputs/WizardTextInput';
import TooltipHelpIcon from 'components/v2/icons/TooltipHelpIcon';
import { useTranslation } from 'react-i18next';
import { useUpsertEpdConversionFactor } from 'services/api/mutations';
import { useEpdConversionFactor, useEpdReferenceFlow } from 'services/api/queries';
import { FieldPanel, FieldPanelHeader } from 'styles/v2/Styles.styled';
import { ConversionFactorModel } from 'types/types';

const ConversionFactorSection: React.FunctionComponent<{
  epdVersionId: string;
  errors?: any;
}> = ({ epdVersionId, errors }) => {
  const { t } = useTranslation();
  const conversionFactorData = useEpdConversionFactor(epdVersionId!).data;
  const upsertEpdConversionFactor = useUpsertEpdConversionFactor(epdVersionId);
  const referenceFlowData = useEpdReferenceFlow(epdVersionId!).data;

  const onChangeConversionFactor = async (propertyName: string, val: any) => {
    const newData = { ...conversionFactorData, [propertyName]: val } as ConversionFactorModel;
    upsertEpdConversionFactor.mutate(newData);
  };

  return (
    <FieldPanel>
      <FieldPanelHeader className="w-full">
        {t(`epdCompiler.step3.lcaSpecificationTab.properties.conversionFactor.title`)}{' '}
        <TooltipHelpIcon content={t(`epdCompiler.step3.lcaSpecificationTab.properties.conversionFactor.tooltip`)} />
      </FieldPanelHeader>
      <WizardTextInputComponent
        label={t(`epdCompiler.step3.lcaSpecificationTab.properties.conversionFactor.unit`)}
        name="unitId"
        disabled
        value="-"
      />
      <WizardNumberInput
        key={referenceFlowData?.unitId}
        label={t(`epdCompiler.step3.lcaSpecificationTab.properties.conversionFactor.value`)}
        name="value"
        placeholder="Type number"
        defaultValue={conversionFactorData?.value ?? null}
        onChanged={onChangeConversionFactor}
        error={errors?.conversionFactorToMass}
        maxFractionDigits={7}
      />
    </FieldPanel>
  );
};

export default ConversionFactorSection;
